import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import axios from "axios";
import { apiRoot, UserContext } from "..";
import { Spinner } from "react-bootstrap";

const DeleteRegistrationRequestModal = (props) => {
  return (
    <Modal
    show={props.show}
    onHide={props.handleCancel}
    backdrop="static"
    keyboard={false}
    >
    <Modal.Header closeButton>
      <Modal.Title>Odstranit žádost o registraci</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {props.errorMessage && <div className="alert alert-danger" role="alert">{props.errorMessage}</div>}
      Chcete opravdu odstranit tuto žádost o registraci?
    </Modal.Body>
    <Modal.Footer>
      {props.proceeding ? <Spinner as="span" animation="border" size="sm" /> : <></>}
      <Button variant="secondary" onClick={props.handleCancel} disable={props.proceeding.toString()}>Zrušit</Button>
      <Button variant="danger" onClick={props.handleProceed} disable={props.proceeding.toString()}>
        <i className="fa fa-trash-o" aria-hidden="true"></i> Odstranit žádost
      </Button>
    </Modal.Footer>
    </Modal>
  )
}

const Users = () => {
  const loggedInUser = useContext(UserContext);
  const queryClient = useQueryClient();

  const fetchRegistrationRequestsQuery = useQuery(['fetchRegistrationRequests'], async () => {
    const {data} = await axios.get(apiRoot + '/user-registration-requests');
    return data;
  }, {
    onError: (err) => {
      console.log('fetchRegistrationRequests error: ' + err) // TODO
    }
  });

  const fetchUsersQuery = useQuery(['fetchUsers'], async () => {
    const {data} = await axios.get(apiRoot + '/users');
    return data;
  }, {
    onError: (err) => {
      console.log('fetchUsers error: ' + err) // TODO
    }
  });

  // const setNotificationsMutation = useMutation((notifications) => {
  //   return axios.post(apiRoot  + '/users/' + user.userId + '/notifications', notifications);
  // },
  // {
  //   onSuccess: () => {
  //     setUser(user => ({...user, isNotified: !user.isNotified}));
  //   },
  //   onError: (error) => {
  //     console.log("setNotificationsMutation error: " + error) // TODO
  //   }
  // });

  // const handleSetNotificationsClick = (val) => {
  //   setNotificationsMutation.mutate({notified: val});
  // }

  const [registrationRequestIdForDelete, setRegistrationRequestIdForDelete] = useState(null);

  const deleteRegistrationRequestMutation = useMutation((registrationRequestIdForDelete) => {
    return axios.delete(apiRoot  + '/user-registration-requests/' + registrationRequestIdForDelete);
  },
  {
    onSuccess: () => {
      queryClient.invalidateQueries(['fetchRegistrationRequests']);
      setRegistrationRequestIdForDelete(null);  
    },
    onError: (error) => {
      console.log("deleteRegistrationRequestMutation error: " + error) // TODO
    }
  });

  const deleteRegistrationRequestProceed = () => {  
    deleteRegistrationRequestMutation.mutate(registrationRequestIdForDelete);
  };

  const deleteRegistrationRequestCancel = () => {
    setRegistrationRequestIdForDelete(null);
    deleteRegistrationRequestMutation.reset();
  };
  
  const [showInactive, setShowInactive] = useState(false);

  return (
    <>
<div>
<span>
<i className="fa fa-handshake-o fa-3x fa-in-header align-middle" aria-hidden="true"></i>
<h2 className="d-inline-block align-middle">Žádosti o registraci</h2>
</span>
</div>
{fetchRegistrationRequestsQuery.isLoading &&
<div className="text-center">
  <Spinner animation="border" variant="secondary" role="status">
    <span className="visually-hidden">Nahrávám...</span>
  </Spinner>
</div>
}
{fetchRegistrationRequestsQuery.isError &&
  <div className="alert alert-danger" role="alert">Chyba při nahrávání žádostí o registraci.</div>
}
{fetchRegistrationRequestsQuery.data && 
  <table class="table">
    <thead class="thead-default">
    <tr>
    <th>Jméno a příjmení</th>
    <th>Číslo bytu</th>
    <th>E-mail</th>
    <th>Telefon</th>
    <th>Status</th>
    <th>Původce statusu</th>
    <th>&nbsp;</th>
    </tr>
    </thead>
    <tbody> 
    {fetchRegistrationRequestsQuery.data.map(userRegistrationRequest => (
      <tr key={userRegistrationRequest.id}>
      <td>{userRegistrationRequest.name}</td>
      <td>{userRegistrationRequest.appartmentNo}</td>
      <td>{userRegistrationRequest.mail}</td>
      <td>{userRegistrationRequest.phone}</td>
      <td>{userRegistrationRequest.status}</td>
      <td>{userRegistrationRequest.statusOriginator}, {userRegistrationRequest.statusChanged}</td>
      <td>&nbsp;{userRegistrationRequest.status === "NEW" && <a href="user_add.php?request=$usersRequests[i].requestId" class="btn btn-success" role="button"><i class="fa fa-check" aria-hidden="true"></i> Vytvořit uživatele</a>}
        <button className="btn btn-danger" onClick={() => {setRegistrationRequestIdForDelete(userRegistrationRequest.id)}}><i className="fa fa-trash-o" aria-hidden="true"></i> Odstranit žádost</button></td>
      </tr>
    ))}
  </tbody>
  </table>
}
<div>&nbsp;</div>
<div>
<span>
<i className="fa fa-users fa-3x fa-in-header align-middle" aria-hidden="true"></i>
<h2 className="d-inline-block align-middle">Uživatelé</h2>
</span>
{loggedInUser && loggedInUser.isPowerUser &&
<span> <Link to={"/pridat-uzivatele"} className="btn btn-success align-middle" role="button"><i className="fa fa-plus" aria-hidden="true"></i> Přidat uživatele</Link></span>
}
</div>
{fetchUsersQuery.isLoading &&
<div className="text-center">
  <Spinner animation="border" variant="secondary" role="status">
    <span className="visually-hidden">Nahrávám...</span>
  </Spinner>
</div>
}
{fetchUsersQuery.isError &&
  <div className="alert alert-danger" role="alert">Chyba při nahrávání uživatelů.</div>
}
{fetchUsersQuery.data && 
<>
  <table class="table">
    <thead class="thead-default">
    <tr>
    <th>Jméno a příjmení</th>
    <th>Číslo bytu</th>
    <th>E-mail</th>
    <th>Telefon</th>
    <th>Status</th>
    <th>Notifikace</th>
    {loggedInUser.isAdmin &&
    <th>Přihlášení</th>
    }
    <th>&nbsp;</th>
    </tr>
    </thead>
    <tbody> 
    {fetchUsersQuery.data
      .filter(user => showInactive || user.status !== "neaktivní")
      .map(user => (
      <tr key={user.id}>
      <td>{user.name}</td>
      <td>{user.appartmentNo}</td>
      <td>{user.mail}</td>
      <td>{user.phone}</td>
      <td>{user.status}</td>
      <td>{user.notifications}</td>
      {loggedInUser &&
      <td>{user.lastLogin}</td>
      }
      <td width={'20%'}>&nbsp;{user.showEdit && <a href="user_edit.php?id={$users[i].userId}" class="btn btn-primary" role="button"><i class="fa fa-pencil" aria-hidden="true"> </i> Upravit</a>}
      {user.showDeactivate && <>&nbsp;<a href="user_deactivate_do.php?id={$users[i].userId}" class="btn btn-danger" role="button" onclick="return confirm('Opravdu chcete deaktivovat uživatele?');"><i class="fa fa-times" aria-hidden="true"></i> Deaktivovat</a></>}
      {user.showActivate && <>&nbsp;<a href="user_activate_do.php?id={$users[i].userId}" class="btn btn-success" role="button"  onclick="return confirm('Opravdu chcete reaktivovat uživatele?');"><i class="fa fa-life-ring" aria-hidden="true"></i> Aktivovat</a></>}</td>
      </tr>
    ))}
  </tbody>
  </table>

  {showInactive === true ?
  (<> <button className="btn btn-secondary" disable={fetchUsersQuery.isLoading.toString()} onClick={() => {setShowInactive(false)}}>Skrýt neaktivní</button></>) :
  (<> <button className="btn btn-secondary" disable={fetchUsersQuery.isLoading.toString()} onClick={() => {setShowInactive(true)}}>Zobrazit včetně neaktivních</button></>)
  }
</>
}
  <DeleteRegistrationRequestModal show={registrationRequestIdForDelete} proceeding={deleteRegistrationRequestMutation.isLoading}
    handleProceed={deleteRegistrationRequestProceed} handleCancel={deleteRegistrationRequestCancel}
    errorMessage={deleteRegistrationRequestMutation.isError ? deleteRegistrationRequestMutation.error.message : null} />
    </>
  );
};

export default Users;